import { orderDateStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDate";
import { COLORS, TYPOGRAPHY } from "@store/theme/common/design";
import { css } from "styled-components";

Object.assign(orderDateStyles, {
    wrapper: {
        css: css`
            // removed styles
        `,
    },
    titleText: {
        size: 18,
        weight: TYPOGRAPHY.weight.bold,
        color: COLORS.text.dark,
    },
    orderDate: {
        size: 16,
        color: COLORS.text.dark,
        css: css`
            margin-left: 10px;
        `,
    },
});
